export const COUNTER_COLORS = {
  base: '#6B7280',
  red: '#DC2626',
  yellow: '#D97706',
}

export function resolveCounterColor(code) {
  return COUNTER_COLORS[code] || COUNTER_COLORS.base
}
